export default __webpack_public_path__ + "static/media/placeholder_business06-it-mobile.34e1ca38.png";